import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74307a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper flex w-full"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-text flex-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "banner-title" }, "$1 000 000 Grant"),
  /*#__PURE__*/_createElementVNode("div", { class: "banner-subtitle" }, "For creating memecoins")
], -1))

import { computed } from 'vue';
import { LAYOUT_MODE } from '@/constants/LAYOUT_PARAMS';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useUtils } from '@/composables/utils/useUtils';
import { FAIR_LAUNCH_DOCS } from '@/constants/EXTERNAL_LINKS';


export default /*#__PURE__*/_defineComponent({
  __name: 'FairLaunchBanner',
  setup(__props) {

const { state } = useStore();
const route = useRoute();
const { openExternalLink } = useUtils();

const coinsImg = computed(() => {
  let images = [
    `/images/banners/fair-launch/coins-left-${state.layout.viewMode}.png`,
    `/images/banners/fair-launch/coins-right-${state.layout.viewMode}.png`,
  ];
  if (state.layout.viewMode === LAYOUT_MODE.MOBILE)
    images.splice(1, 0, `/images/banners/fair-launch/coins-middle-mobile.png`);
  return images;
});
const supportedPages = ['Swap', 'Farming', 'Staking', 'Portfolios', 'SingleSide'];
const isShowBanner = computed(() => supportedPages.includes(route.name as string));

return (_ctx: any,_cache: any) => {
  return (_unref(isShowBanner))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "banner fair-launch-banner relative",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openExternalLink)(_unref(FAIR_LAUNCH_DOCS))))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coinsImg), (image, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "inline-flex"
            }, [
              _createElementVNode("img", {
                src: image,
                alt: "",
                class: "coins"
              }, null, 8, _hoisted_2)
            ]))
          }), 128)),
          _hoisted_3
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})